<template>
  <div class="p-grid p-fluid" style="padding-bottom: 2%"  >
    <Panel header="Perfis de Acesso" class="p-col-12">
      <Dropdown
        v-model="perfilSelect"
        :options="perfis"
        optionLabel="nomePerfilAcesso"
        placeholder="Selecione um Perfil"
        
      />
    </Panel>
    
    <Panel header="Vínculos do usuário" class="p-col-12">
      <div class="p-col-12">
      
        <DataTable :value="cDadosVinculos" :selection.sync="vinculoSelecionado">
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column field="numrVinculo" header="Nº"></Column>
          <Column field="orgao.descOrgao" header="Órgão"></Column>
          <Column field="unidade.descUnidade" header="Unidade"></Column>
          <Column field="tipoVinculo.descTipoVinculo" header="Tipo"></Column>
          <Column field="statVinculo" header="Status"></Column>
          <Column field="perfil.nomePerfilAcesso" header="Nome">
            <template #body="slotProps">
              <label v-if="slotProps.data.perfil.length == 0">&nbsp;</label>
              <label v-else>{{slotProps.data.perfil[0].perfilAcesso.nomePerfilAcesso}}</label>
            </template>
          </Column>
          <Column field="perfil.autorizacoes" header="Descrição do Perfil">
            <template #body="slotProps">
              <label v-if="slotProps.data.perfil.length == 0">&nbsp;</label>
              <label v-else>{{slotProps.data.perfil[0].perfilAcesso.autorizacoes[0].data.nomeExibir}}</label>
            </template>
          </Column>
        </DataTable>
      </div>
      
      <div class="p-col-12 p-md-2" style="float:right">
        <br>
        <Button
          label="Remover"
          class="p-button-danger"
          icon="pi pi-check"
          style="margin-top:1rem"
          @click="removerPerfilVinculo()"
          :disabled="vinculoSelecionado.length == 0"          
        />
      </div>
    
      <div class="p-col-12 p-md-2" v-if="perfis" style="float:right">
        <br>
        <Button
          label="Aplicar"
          class="p-button-success"
          icon="pi pi-check"
          style="margin-top:1rem"
          @click="alterarPerfil()"
          :disabled="perfilSelect==null || vinculoSelecionado.length == 0"          
        />
      </div>

    </Panel>
  </div>
</template>
<script>
import { printToast } from "@/config/global";
import { baseApiUrl} from "@/config/global";
import { mapMutations } from "vuex";

export default {
  name: 'usuario-perfil',
  components: {  },
  props: {
   data:{
      type:Object,
      require: true
    },
    perfis: {
      type: Array,
      require: true
    },   
    temPerfilFiscalizador: {
      type: Boolean,
      require: true
    }, 
    dadosVinculos : {
      type: Array,
      require: true
    },  
  },
  computed: {
      cDadosVinculos: {
        get: function() {
          return this.dadosVinculos
        },
        set: function(val) {
          this.$emit('atualizarDadosVinculo', val)
        }
      },
      cTemPerfilFiscalizador: {
        get: function() {
          return this.temPerfilFiscalizador
        },
        set: function(val) {
          this.$emit('habilitarAbaFiscalizador', val)
        }
      }
    },
  methods: {
    ...mapMutations['setIsRefreshMenu'],
    
    onRowSelect(event) {
        this.$toast.add({severity: 'info', summary: 'Car Selected', detail: 'Vin: ' + event.data.vinculo.idenVinculo, life: 3000});
    },
    onRowUnselect(event) {
        this.$toast.add({severity: 'warn', summary: 'Car Unselected', detail: 'Vin: ' + event.data.vinculo.idenVinculo, life: 3000});
    },
    adicionarPerfil(){
      if(this.perfilSelect){
        printToast({severity: 'success', summary: 'Cadastrado com sucesso', detail: 'Selecione o botão Salvar para concluir a Edição', life: 10000})
          this.data.perfis.push({ contaAcesso: this.data.id, perfilAcesso: this.perfilSelect })
      }else{        
        printToast({severity: 'error', summary: 'Erro!', detail: 'Porfavor selecione um Perfil'})
      }
    },

    async alterarPerfil(){

      let jsonVinculoPerfil = []

      this.vinculoSelecionado.forEach(element => {
        jsonVinculoPerfil.push({"idenVinculo" : element.idenVinculo, "idenPerfilAcesso" : this.perfilSelect.id})
      });

      this.vinculoSelecionado = []


      await this.$http
        .put(`${baseApiUrl}/seguranca/perfilacessos/vinculos`, JSON.stringify(jsonVinculoPerfil))
        .then(() => {
            printToast({severity: 'success', summary: 'Sucesso', detail: 'Perfil atualizado com sucesso'})
            
            if(this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa == this.data.pessoa.idenPessoa){
              let LocalStorageSeplag = localStorage.getItem(process.env.VUE_APP_USER_KEY)
              let storageSeplagJson = JSON.parse(atob(LocalStorageSeplag))
              storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca = null
  
              localStorage.setItem(
                process.env.VUE_APP_USER_KEY,
                btoa(JSON.stringify(storageSeplagJson))
              );
              this.$store.dispatch("buscarUsuario", this)
            }
        });

        await this.$http.get(`${baseApiUrl}/vinculos/pessoa/${this.data.pessoa.idenPessoa}`).then((res) => {
          let cDadosVinculos_temp = res.data;
          this.tDadosVinculos = []
          cDadosVinculos_temp.forEach(vinc => {
            vinc.perfil = []
            this.$http.get(`${baseApiUrl}/seguranca/perfilvinculos/vinculo/${vinc.idenVinculo}`).then((res) => {
              vinc.perfil = res.data;
              if(res.data.length>0){
                if(res.data[0].perfilAcesso.nomePerfilAcesso == "FISCALIZADOR - DECLARACAO"){
                  this.cTemPerfilFiscalizador = true
                } 
              }
            }); 
            this.tDadosVinculos.push(vinc)
          })
          this.cDadosVinculos = this.tDadosVinculos
        }); 

    },

    async removerPerfilVinculo(){ 
      
      let jsonIdenPerfilVinculo = [] 

      this.vinculoSelecionado.forEach(element => {
          if(element.perfil.length>0){
            jsonIdenPerfilVinculo.push(element.perfil[0].idenPerfilVinculo)
          }   
      });      
     
      this.vinculoSelecionado = []  

      await this.$http
        .put(`${baseApiUrl}/seguranca/perfilvinculos/remover`, JSON.stringify(jsonIdenPerfilVinculo))
        .then(() => {
            printToast({severity: 'success', summary: 'Sucesso', detail: 'Perfil removido com sucesso'})
            
            if(this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa == this.data.pessoa.idenPessoa){
              let LocalStorageSeplag = localStorage.getItem(process.env.VUE_APP_USER_KEY)
              let storageSeplagJson = JSON.parse(atob(LocalStorageSeplag))
              storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca = null
  
              localStorage.setItem(
                process.env.VUE_APP_USER_KEY,
                btoa(JSON.stringify(storageSeplagJson))
              );
              this.$store.dispatch("buscarUsuario", this)
            }
        });

        await this.$http.get(`${baseApiUrl}/vinculos/pessoa/${this.data.pessoa.idenPessoa}`).then((res) => {
          let cDadosVinculos_temp = res.data;
          this.tDadosVinculos = []
          cDadosVinculos_temp.forEach(vinc => {
            vinc.perfil = []
            this.$http.get(`${baseApiUrl}/seguranca/perfilvinculos/vinculo/${vinc.idenVinculo}`).then((res) => {
              vinc.perfil = res.data;
              if(res.data.length>0){
                if(res.data[0].perfilAcesso.nomePerfilAcesso == "FISCALIZADOR - DECLARACAO"){
                  this.cTemPerfilFiscalizador = true
                } 
              }
            }); 
            this.tDadosVinculos.push(vinc)
          })
          this.cDadosVinculos = this.tDadosVinculos
        }); 
    },

    removerUsuarioPerfil(dados){
      this.data.perfis = this.data.perfis.filter(function(el) {
          return el.perfilAcesso.id != dados.perfilAcesso.id
      })
      printToast({severity: 'success', summary: 'Removido com sucesso', detail: 'Selecione o botão Salvar para concluir a Edição', life: 10000})
    }
  },
  data: function () {
    return {
      perfilSelect: null,
      //jsonIdenPerfilVinculo : [],
      vinculoSelecionado: [],
      tDadosVinculos : [],
      pVinculosPerfilPessoa: this.vinculosPerfilPessoa,
      camposTabela: [
        { titulo: "Perfil de Acesso", nome: "perfilAcesso.nomePerfilAcesso"},
        { titulo: "Sistema", nome:"perfilAcesso.sistema.nomeSistema"},
      ]
    };
  },
  
  

  mounted() {
    //this.carregarDadosPerfil();
  }
};

</script>
